<template>
  <v-app>
    <router-view class="mt-0"></router-view>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({}),
};
</script>

<style>
.title-icon-application {
  font-size: 11px !important;
}

td,
.v-input--selection-controls .v-radio > .v-label {
  font-size: 0.8rem !important;
}

td.custom-price {
  font-size: 1rem !important;
  font-weight: 600;
}

td {
  height: 25px !important;
}

td.td-custom {
  background: #e2e2e2;
  width: 176px;
}

td.td-head-custom {
  background: #8f8f8f;
  color: #fff;
  font-size: 1rem !important;
}

.input-quotation {
  position: relative;
  bottom: 4px;
  border-bottom: 0;
}

input {
  font-size: 14px;
}

.v-text-field input {
  padding-left: 3px;
}

.v-select.v-input--dense .v-select__selection--comma {
  margin: 8px 4px 0px 0 !important;
}

.theme--light.v-select .v-select__selection--disabled,
.v-select__selection--comma,
.v-select:not(.v-text-field--single-line):not(.v-text-field--outlined)
  .v-select__slot
  > input {
  font-size: 13px !important;
  color: #333 !important;
}

.v-select:not(.v-text-field--single-line):not(.v-text-field--outlined)
  .v-select__slot
  > input,
.v-text-field.v-input--dense:not(.v-text-field--outlined) input {
  padding: 6px 0 0px 0px !important;
  font-size: 13px !important;
  color: #333 !important;
}

.v-list-group {
  width: 100%;
}

.v-list-group__header {
  padding: 0 !important;
}

.menu-drop-down {
  font-size: 12px;
  font-weight: 500;
}

.v-list-group__header__append-icon {
  position: absolute;
  right: 0;
}
</style>